import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper-content" }
const _hoisted_2 = {
  key: 1,
  class: "message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    "is-open": $setup.props.isOpen,
    onClose: $setup.close,
    classes: "not-verified-modal"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("h2", null, "In order to log in, you need to go to the mail and follow the link", -1)),
        ($setup.showButton)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button primary large",
              onClick: $setup.resend
            }, "Resend email confirmation link"))
          : _createCommentVNode("", true),
        ($props.message)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($props.message), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["is-open"]))
}